module.exports = __webpack_public_path__ + "static/hyperv_35.9928aefa.jpg";